import { RouterName } from "@/models/common";
import router from "@/router";
import { useStore } from "@/store";
import { AuthMutationTypes } from "@/store/modules/auth/mutations";
import axios, { AxiosError } from "axios";
import Cookies from "js-cookie";

const API_HOST = process.env.VUE_APP_SERVICE_ENDPOINT;

// const API_HOST =
//   process.env.NODE_ENV === "production"
//     ? process.env.VUE_APP_SERVICE_ENDPOINT
//     : "https://localhost:44364/PohrTm";
// const API_HOST = 'https://localhost:44364/PohrTm';
// const API_HOST = 'https://192.168.10.91:44364/PohrTm';
// const API_HOST = 'https://heselinc.iptime.org:58444';
//const API_HOST = "https://care.hesel.clinic:9443/heselcare";

//export const VIDEO_HOST =
//  process.env.NODE_ENV === 'production' ? 'https://care.hesel.clinic:50443' : 'https://localhost:3000';

console.log(API_HOST, "API_HOST");

const api = axios.create({ baseURL: `${API_HOST}` });

const clearToken = () => {
  const store = useStore();
  store.commit(AuthMutationTypes.CLEAR_TOKEN);
};

let tryCount = 0;

const refreshToken = async () => {
  if (tryCount > 10) {
    return null;
  }
  tryCount++;

  const token = Cookies.get("refresh_token");
  console.log(token, "refreshToken.token");
  if (token === undefined || token === null || token.length <= 0) return false;

  try {
    const resp = await api.get("api/ApiSignV2/RefreshToken/?token=" + token);
    console.log(resp, "refreshToken.resp");

    if (resp.data) {
      const { ResultCode, ResultData } = resp.data;
      if (ResultCode === 0 && ResultData) {
        const { accessToken } = ResultData;
        if (accessToken && accessToken.length > 0) {
          const store = useStore();
          store.commit(AuthMutationTypes.SET_TOKEN, accessToken);
          return accessToken;
        }
      }
    }
    return null;
  } catch (ex) {
    console.error(ex, "refreshToken.ex");
    return null;
  }
};

api.interceptors.response.use(
  (response) => {
    const path = router.currentRoute.value.path;

    console.log("api.interceptors.response.path", path);
    console.log("api.interceptors.response.status", response.status);

    if (response.status === 401) {
      if (router.currentRoute.value.name !== RouterName.SIGNIN) {
        clearToken();
        router.push({ name: RouterName.SIGNIN });
      }
    }
    //ssr로 로그인 화면 소스가 response되면 토큰 초기화 후 로그인 화면으로 이동
    if (typeof response.data === "string") {
      // chglee clearToken();
      //if (!path.startsWith('/signin')) router.push({ name: RouterName.SIGNIN, query: { redirect: path } });
      //response.data = '';
    }
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      console.log(error.response, "error.response");

      const config = { ...error.config, ...{} };

      console.log(config, "error.config");

      refreshToken()
        .then((token) => {
          if (token && token.length > 0) {
            config.headers["Authorization"] = "Bearer " + token;
            return api.request(config);
          } else {
            clearToken();
            router.push({ name: RouterName.SIGNIN });
          }
        })
        .catch((ex) => {
          console.log(ex, "refreshToken().ex");
          clearToken();
          router.push({ name: RouterName.SIGNIN });
        });

      return;
    }

    //로그인이 필요한 페이지
    const fullPath = router.currentRoute.value.fullPath;
    if (
      fullPath.startsWith("/online-care") ||
      fullPath.startsWith("/second-opinion") ||
      fullPath.startsWith("/mypage") ||
      fullPath.startsWith("/profile")
    ) {
      if (error.response?.status !== 401) return Promise.reject(error);

      if (router.currentRoute.value.name !== RouterName.SIGNIN) {
        clearToken();
        router.push({ name: RouterName.SIGNIN });
      }
    } else return;
  },
);

api.defaults.withCredentials = true;
export default api;
